var iframe = document.getElementById('iframe_a');

iframe.onload = function() {
  var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

  var elementIdsToScrollTo = ['#aesthetic-injectables', '#coolsculpting', '#lhr', '#hifu', '#ipl', '#microneedling', '#book'];

  elementIdsToScrollTo.forEach(function(elementId) {
    var targetElement = iframeDocument.getElementById(elementId);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.log('Target element not found within the iframe content: ' + elementId);
    }
  });
};
iframe.src = 'https://vicpark.com/avanti/';